import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useConsent } from '../hooks/useConsent';

// GDPR / ePrivacy cookie banner. Shows only while consent is undecided (null),
// which by default happens only in the EU/EEA/UK/CH — see useConsent.
const CookieConsent = () => {
    const { t } = useTranslation();
    const { consent, accept, reject } = useConsent();

    if (consent) return null;

    return (
        <div className="cookie" role="dialog" aria-live="polite" aria-label={t('cookieConsent.title')}>
            {/* Clarity's session recordings are covered by "analytics cookies" plus the
                policy link; the policy spells them out. */}
            <Trans
                i18nKey="cookieConsent.text"
                components={{
                    // The placeholder child keeps jsx-a11y happy (CI fails the build on
                    // warnings); Trans replaces it with the <policy> text from the locale.
                    policy: <a className="link" href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>,
                }}
            />
            {/* Accept leads, but decline is a real button beside it rather than a
                muted link — the demo's own note is "declines by default", and a
                banner where only one answer looks like a button is not a choice. */}
            <div className="cookie-actions">
                <button type="button" className="btn btn-grad btn-sm" onClick={accept}>
                    {t('cookieConsent.accept')}
                </button>
                <button type="button" className="btn btn-ghost btn-sm" onClick={reject}>
                    {t('cookieConsent.reject')}
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
